import { render, staticRenderFns } from "./fundAnalysis.vue?vue&type=template&id=3fbdac0d&scoped=true"
import script from "./fundAnalysis.vue?vue&type=script&lang=js"
export * from "./fundAnalysis.vue?vue&type=script&lang=js"
import style0 from "./fundAnalysis.vue?vue&type=style&index=0&id=3fbdac0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbdac0d",
  null
  
)

export default component.exports